import { Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { AdvisoryService } from "../../../Component/Api/Advisory/AdvisoryService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { ClientScorecard, ClientScorecardSearchRequest } from "../../../Component/Model/Dto/Advisory/ClientScorecard";
import { useParams } from "react-router-dom";
import { ClientScorecardDataTableColumns } from "./ClientScorecardsDataTableColumns";
import { useSetRecoilState } from "recoil";
import { ClientRegistrationAtom } from "../../../State/Advisory/ClientRegistration.Atom";

interface RouteParams { 
    registrationId: string; 
    registrationName: string; 
}

export const ClientScorecards = () => {
    const [scorecardData, setScorecardData] = useState<ClientScorecard[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [filteredItemCount, setFilteredItemCount] = useState<number>(0);
    const [totalItemCount, setTotalItemCount] = useState<number>(0);
    const setClientRegistration = useSetRecoilState(ClientRegistrationAtom);
    const { registrationId, registrationName } = useParams<RouteParams>();

    const clientScorecardSearchRequest: ClientScorecardSearchRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        columnSortOptions: columnSortOptions
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }
    
    useEffect(() => {
        setClientRegistration({clientRegistrationId: registrationId, clientRegistrationName: registrationName});
    }, [registrationId,
        registrationName
    ]);

    useEffect(() => {
        if (registrationId != ':registrationId') {
            fetchClientScorecards();
        }
    }, [entriesPerPage,
        pageNumber,
        columnSortOptions,
        searchValue
    ]);


    const fetchClientScorecards = async () => {
        setIsLoading(true);
        try {
            const clientScorecardResult = await AdvisoryService.searchClientScorecards(registrationId, clientScorecardSearchRequest);
            
            setScorecardData(clientScorecardResult.data.results);
            setFilteredItemCount(clientScorecardResult.data.filteredItemsCount);
            setTotalItemCount(clientScorecardResult.data.totalItemsCount);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const clientScorecardTable = ClientScorecardDataTableColumns(scorecardData);
    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                Client Scorecards
            </Typography>

            <DataTable
                table={clientScorecardTable}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemCount}
                totalItemsCount={totalItemCount}
                isLoading={isLoading}
                manualSorting={true}
                canSearch
                searchValueChanged={searchValueChanged}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                columnSortingChanged={columnSortingChanged} />


        </>
    )
}

